
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Language() {
  const navigate = useNavigate();
  const [selectedLanguage, setSelectedLanguage] = useState<string>('');

  const handleLanguageSelect = (language: string) => {
    setSelectedLanguage(language);
    localStorage.setItem('selectedLanguage', language);
    
    setTimeout(() => {
      navigate('/auth');
    }, 500);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      {/* Header */}
      <div className="text-center mb-12">
        <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
          <i className="ri-global-line text-3xl text-white"></i>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          اختر لغتك المفضلة
        </h1>
        <p className="text-gray-600">
          Choose Your Preferred Language
        </p>
      </div>

      {/* Language Options */}
      <div className="w-full max-w-sm space-y-4">
        <button
          onClick={() => handleLanguageSelect('ar')}
          className={`w-full p-6 rounded-2xl border-2 transition-all duration-300 ${
            selectedLanguage === 'ar'
              ? 'border-blue-500 bg-blue-50 shadow-lg'
              : 'border-gray-200 bg-white hover:border-blue-300 hover:shadow-md'
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="text-right">
              <h3 className="text-xl font-bold text-gray-800 font-arabic">العربية</h3>
              <p className="text-gray-600 text-sm font-arabic">اللغة العربية</p>
            </div>
            <div className="text-3xl">🇸🇦</div>
          </div>
        </button>

        <button
          onClick={() => handleLanguageSelect('en')}
          className={`w-full p-6 rounded-2xl border-2 transition-all duration-300 ${
            selectedLanguage === 'en'
              ? 'border-blue-500 bg-blue-50 shadow-lg'
              : 'border-gray-200 bg-white hover:border-blue-300 hover:shadow-md'
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="text-left">
              <h3 className="text-xl font-bold text-gray-800">English</h3>
              <p className="text-gray-600 text-sm">English Language</p>
            </div>
            <div className="text-3xl">🇺🇸</div>
          </div>
        </button>
      </div>

      {/* Continue Button */}
      {selectedLanguage && (
        <div className="mt-8 animate-fade-in">
          <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full mx-auto"></div>
        </div>
      )}

      <style jsx>{`
        .font-arabic {
          font-family: 'Tajawal', 'Noto Sans Arabic', sans-serif;
        }
        
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fade-in {
          animation: fade-in 0.5s ease-out;
        }
      `}</style>
    </div>
  );
}
